// extracted by mini-css-extract-plugin
export default {"modal":"billActions_modal__nFKF9","box":"billActions_box__fP6Oi"};